import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from 'src/App';
import { AbilityProvider } from 'src/components/AbilityProvider';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import ScrollTop from 'src/hooks/useScrollTop';
import * as serviceWorker from 'src/serviceWorker';
import config from 'src/utils/config';

import 'src/utils/axios-setup';

import ReduxProvider from './store/redux/provider';

import 'nprogress/nprogress.css';
import './index.css';

// Remember which environment the user is on, shared across all *.console.sonio-group.com subdomains
if (window.location.hostname.includes('console.sonio-group.com')) {
  document.cookie = `last_env=${window.location.hostname}; domain=.console.sonio-group.com; path=/; max-age=86400; SameSite=Lax`;
}

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <ReduxProvider>
      <Auth0Provider
        domain="dev-sitk24ss2iowl228.eu.auth0.com"
        clientId="PXQf6LMyGxcF3efkqCOJ1EO1wfSfqzR6"
        authorizationParams={{
          redirect_uri: `${window.location.origin}/callback`,
          audience: config.audience,
        }}
        useRefreshTokens={true}
        cacheLocation="localstorage"
        useRefreshTokensFallback={true}
      >
        <AbilityProvider>
          <SidebarProvider>
            <BrowserRouter>
              <ScrollTop />
              <App />
            </BrowserRouter>
          </SidebarProvider>
        </AbilityProvider>
      </Auth0Provider>
    </ReduxProvider>
  </HelmetProvider>,
);

serviceWorker.unregister();
